import R from 'ramda';
import React, { PropTypes as pt } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getLanguages } from '../selectors';
import { selectLanguage } from '../actions';

class CmpLanguageSelector extends React.Component {
    static propTypes = {
        languages: pt.arrayOf(pt.shape()),
        onLanguageSelected: pt.func.isRequired,
    };

    renderLanguage = language => {
        return (
            <LanguageItem key={language.id} onClick={() => this.props.onLanguageSelected(language.code)}>
                <img src={language.small_icon} className="mb-2 rounded-circle" width="46" height="46" alt={"{language.name} язык на speakASAP"}/>
                <span>{language.name}</span>
            </LanguageItem>
        );
    };

    render() {
        const { languages } = this.props;
        return (
            <LanguageSelectorWrapper>
                {R.map(this.renderLanguage, languages)}
            </LanguageSelectorWrapper>
        );
    }
}

const LanguageSelector = connect(
    state => ({
        languages: getLanguages(state),
    }),
    dispatch => ({
        onLanguageSelected: languageCode => dispatch(selectLanguage(languageCode)),
    })
)(CmpLanguageSelector);

export default LanguageSelector;

const LanguageSelectorWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
`;


const LanguageItem = styled.div`
    padding: 0 20px;
    margin: 0 10px 20px;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
    
    &:hover {
        cursor: pointer;
        
        img {
            box-shadow: 0 0 10px #9FA8DA;
        }
    }
    
    span {
        font-size: 70%;
        color: #fff;
    }
    
    img {
        width: 46px;
        height: 46px;
        border: 3px solid #1976d2;
        border-radius: 50%;
        display: block;
    }
`;



// WEBPACK FOOTER //
// ./src/marathons/components/LanguageSelector.jsx